import { atom } from 'nanostores';

/**
 * Bridge for "attach a file" requests raised outside the composer.
 *
 * The routing rules for a picked file (image → attach, first PDF → ask whether
 * it's a brochure to build from, later PDFs → follow the locked mode) live in
 * ChatBox and are non-trivial. Rather than duplicate them, surfaces that want
 * to start an upload — the hero's brochure line, the hero drop target — publish
 * a request here and ChatBox performs it.
 *
 * `file` null means "open the picker". `seq` makes repeat requests distinct.
 */
export interface ComposerUploadRequest {
  seq: number;
  file: File | null;
}

export const $composerUploadRequest = atom<ComposerUploadRequest>({ seq: 0, file: null });

/** Open the composer's file picker. */
export function requestComposerUpload() {
  $composerUploadRequest.set({ seq: $composerUploadRequest.get().seq + 1, file: null });
}

/** Hand an already-picked file (e.g. a drop) to the composer's routing rules. */
export function submitComposerFile(file: File) {
  $composerUploadRequest.set({ seq: $composerUploadRequest.get().seq + 1, file });
}
